import { render, staticRenderFns } from "./VerifyAccount.vue?vue&type=template&id=15726a08&scoped=true&"
import script from "./VerifyAccount.vue?vue&type=script&lang=js&"
export * from "./VerifyAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15726a08",
  null
  
)

export default component.exports